module.exports = __webpack_public_path__ + "static/media/Ela3.d4fa8123.webp";